import React from 'react';
import FeatureFlagPlaceholder from 'components/ui/FeatureFlagPlaceholder';

export default function VoteDelegation() {
  return (
    <FeatureFlagPlaceholder
      title="Vote Delegation"
      description="Delegate voting rights to trusted representatives with configurable scope, time limits, and revocation controls — available in Phase 2."
      phase="Phase 2"
    />
  );
}
